// @core/api/endpoints/tenant/export_tenant_data.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ExportTenantDataRequest,
  TenantDataExportResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Request tenant data export
 * Initiates a full data export for the tenant in compliance with GDPR Article 20 (data portability). The export is processed asynchronously and a download link is provided upon completion.
 */
export async function ExportTenantData(
  tenant_id: string,
  data: ExportTenantDataRequest,
  options?: RequestOptions
): Promise<TenantDataExportResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/data-export`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.post<TenantDataExportResponse>(requestPath, data, requestOptions);
}
